import React, { useEffect, useState } from 'react'
import '../../ApplicationsDashboard/ApplicationsDashboard.css';
import CustomPagination from '../../../components/Pagination/CustomPagination';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../../components/Sidebar/Sidebar';
import SeedsLogo from "../../../assets/images/SeedsLogo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faSearch,
    faBell,
    faQuestionCircle,
} from "@fortawesome/free-solid-svg-icons";
import UserProfileDropdown from '../../../components/UserProfile/UserProfile';
import './ActiveCustomer.css'
import { useDispatch, useSelector } from 'react-redux';
import { getActiveCustomerReport } from '../../../redux/ReportsReducer/action';
import DatePicker from 'react-datepicker';
import DownloadReport from '../DownloadReport';
import FilterModal from '../FilterModal/FilterModal';
import FunnelIconSvg from '../../../components/SVG/FunnelIconSvg';
import { downloadReport, resetFilters } from '../../../utils/reportUtils';
import { isAuthorised } from '../../../utils/common';
import { REPORTS_COMPONENTS } from '../../../config/reports';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';

const ActiveCustomer = () => {
    let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    let authToken = tokens?.token || null;

    const { activeCustomerReport, pagination, officerProfile } = useSelector((store) => {
        return {
            activeCustomerReport: store.ReportsReducer.activeCustomerReport.data,
            pagination: store.ReportsReducer.activeCustomerReport.pagination,
            officerProfile: store.UserReducer.officerProfile
        }
    }, []);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);

    const leads = [];

    const storedFilters = JSON.parse(sessionStorage.getItem('activeCustomerFilters')) || {};

    const [activeCustomerFilters, setActiveCustomerFilters] = useState({
        app_id: storedFilters?.app_id || "",
        branch_name: storedFilters?.branch_name || "",
        customer_name: storedFilters?.customer_name || "",
        customer_id: storedFilters?.customer_id || "",
        loan_id: storedFilters?.loan_id || "",
        ro_name: storedFilters?.ro_name || "",
        loan_created_from: storedFilters?.loan_created_from || "",
        loan_created_to: storedFilters?.loan_created_to || "",
        global_search: storedFilters?.global_search || ""
    });

    const [currentPage, setCurrentPage] = useState(parseInt(sessionStorage.getItem('reportsCurrentPage')) || 1);
    const [limit, setLimit] = useState(parseInt(sessionStorage.getItem('reportsLimit')) || 10);
    const totalCount = parseInt(sessionStorage.getItem('reportsTotalCount')) || 0;
    const totalPages = Math.ceil(totalCount / limit);

    const [dateRange, setDateRange] = useState([
        activeCustomerFilters?.loan_created_from ? new Date(activeCustomerFilters.loan_created_from) : null,
        activeCustomerFilters?.loan_created_to ? new Date(activeCustomerFilters.loan_created_to) : null,
    ]);

    const [startDate, endDate] = dateRange;

    useEffect(() => {
        dispatch(getActiveCustomerReport(currentPage, limit, activeCustomerFilters, null));

        sessionStorage.setItem('reportsCurrentPage', currentPage);
        sessionStorage.setItem('reportsLimit', limit);
        sessionStorage.setItem('activeCustomerFilters', JSON.stringify(activeCustomerFilters));
        // }, [dispatch, limit, currentPage, activeCustomerFilters]);
    }, [dispatch, limit, currentPage]);

    useEffect(() => {
        return () => {
            sessionStorage.removeItem("activeCustomerFilters");
            sessionStorage.removeItem("reportsCurrentPage");
            sessionStorage.removeItem("reportsLimit");
            sessionStorage.removeItem("reportsTotalPages");
            sessionStorage.removeItem("reportsTotalCount");
        };
    }, []);


    const handlePageChange = (newPage) => {
        // Ensure we're working with 1-based pagination
        const pageToSet = Math.max(1, Math.min(newPage, totalPages));
        setCurrentPage(pageToSet);
        sessionStorage.setItem('currentPage', pageToSet.toString());
    };

    const formatDate = (date) => {
        if (!date) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handleDateRangeChange = (update) => {
        setDateRange(update);

        const [start, end] = update;

        const updatedFilters = {
            ...activeCustomerFilters,
            loan_created_from: formatDate(start),
            loan_created_to: formatDate(end),
        };

        setActiveCustomerFilters(updatedFilters);
        sessionStorage.setItem("activeCustomerFilters", JSON.stringify(updatedFilters));
    };

    const handleFilterChange = (e) => {
        let { name, value } = e.target;

        if (typeof value === 'string') {
            value = value.replace(/[\t\n\r]+/g, '').replace(/^\s+/, '');
        }

        let updatedFilters = {
            ...activeCustomerFilters,
            [name]: value
        };

        setActiveCustomerFilters(updatedFilters);
        sessionStorage.setItem("activeCustomerFilters", JSON.stringify(updatedFilters));
    }

    useEffect(() => {
        sessionStorage.setItem('reportsCurrentPage', currentPage);
        sessionStorage.setItem('reportsLimit', limit);
    }, [limit, currentPage]);

    return (
        <>
            <div className="reportsDashboardContainer">
                <div className="reportsDashboard">
                    <Sidebar />

                    <div className="dashboardMainContent">
                        <div className="contentHeader">
                            <div className="userLogo">
                                <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
                            </div>
                            <div className="headerRightPanel">
                                {/* <div className="headerSearchBar">
                                <input type="text" placeholder="Search" />
                                <FontAwesomeIcon icon={faSearch} />
                            </div>
                            <div className="headerNotifications">
                                <FontAwesomeIcon icon={faBell} />
                                <span className="notificationBadge">9+</span>
                            </div>
                            <div className="headerHelp">
                                <FontAwesomeIcon icon={faQuestionCircle} />
                            </div> */}
                                <UserProfileDropdown />
                            </div>
                        </div>

                        <div className="pageContentWrapper">
                            <div className="pageHeaderSection">
                                <Breadcrumb items={[
                                    { label: 'Admin' },
                                    { label: 'Reports', onClick: () => navigate('/reports') },
                                    { label: 'Active Customer' }
                                ]} />

                                <div className="pageActions">
                                    <h2>Active Customer</h2>
                                </div>
                            </div>

                            <div className="searchControlSection">
                                <div className="searchGroup">
                                    {isAuthorised(
                                        officerProfile,
                                        REPORTS_COMPONENTS['active-customer_search']
                                    ) && <div className="tableSearchBar">
                                            <input
                                                // type="text" 
                                                type="search"
                                                placeholder="Search"
                                                name="global_search"
                                                value={activeCustomerFilters?.global_search}
                                                onChange={handleFilterChange}
                                                onInput={(e) => {
                                                    if (e.target.value === "") {
                                                        let updatedFilters = {
                                                            ...activeCustomerFilters,
                                                            global_search: e.target.value
                                                        }

                                                        setActiveCustomerFilters(updatedFilters)

                                                        dispatch(getActiveCustomerReport(1, limit, updatedFilters));
                                                        handlePageChange(1);
                                                    }
                                                }}
                                            />
                                            {/* <FontAwesomeIcon icon={faSearch} /> */}
                                        </div>}
                                    <div className="searchActionButtons">
                                        {isAuthorised(
                                            officerProfile,
                                            REPORTS_COMPONENTS['active-customer_search']
                                        ) && <button
                                            className="searchButton iconOnly"
                                            title="Search"
                                            onClick={() => {
                                                dispatch(getActiveCustomerReport(1, limit, activeCustomerFilters, null));
                                                handlePageChange(1);
                                            }}
                                        >
                                                <FontAwesomeIcon icon={faSearch} />
                                            </button>}
                                        {isAuthorised(
                                            officerProfile,
                                            REPORTS_COMPONENTS['active-customer_download']
                                        ) && <button
                                            className="downloadButton"
                                            // onClick={() => setShowDownloadModal(true)}
                                            onClick={() => {
                                                downloadReport("active-customer", activeCustomerFilters, setIsDownloading);
                                            }}
                                            disabled={isDownloading}
                                        >
                                                {isDownloading ? (
                                                    <>
                                                        <span className="buttonSpinner"></span>
                                                        Downloading...
                                                    </>
                                                ) : (
                                                    <>
                                                        Download
                                                    </>
                                                )}
                                            </button>}
                                        {isAuthorised(
                                            officerProfile,
                                            REPORTS_COMPONENTS['active-customer_filters']
                                        ) && (
                                                <div className="filterPopoverWrapper">
                                                    <button
                                                        className="filterButton"
                                                        onClick={() => setShowFilterModal(!showFilterModal)}
                                                    >
                                                        <FunnelIconSvg fillColor={"black"} />
                                                    </button>
                                                    {showFilterModal && (
                                                        <FilterModal
                                                            reportTitle={"active-customer"}
                                                            filters={activeCustomerFilters}
                                                            setFilters={setActiveCustomerFilters}
                                                            resetFilters={() => {
                                                                let resettedFilters = resetFilters(activeCustomerFilters);

                                                                setActiveCustomerFilters(resettedFilters);
                                                                dispatch(getActiveCustomerReport(1, limit, resettedFilters, null));
                                                                setShowFilterModal(false);
                                                                sessionStorage.setItem("activeCustomerFilters", JSON.stringify(resettedFilters));
                                                                handlePageChange(1);
                                                                return resettedFilters;
                                                            }}
                                                            handleApplyFilters={(finalFilters) => {
                                                                handlePageChange(1);
                                                                dispatch(getActiveCustomerReport(1, limit, finalFilters, null));
                                                                setShowFilterModal(false);
                                                            }}
                                                            onClose={() => {
                                                                setShowFilterModal(false);
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            )}
                                    </div>
                                </div>
                            </div>



                            <div className="tableCard">
                                <main className="">
                                    <div className="reportsTableContainer">
                                        <table className="applications-table" style={{ overflowX: "auto" }}>
                                            <thead>
                                                <tr>
                                                    <th>Application ID</th>
                                                    <th>Branch</th>
                                                    <th>Customer Name</th>
                                                    <th>Customer ID</th>
                                                    <th>Loan ID</th>
                                                    <th>Tranche ID</th>
                                                    <th>RO - Assigned</th>
                                                    <th>Amount Sanctioned</th>
                                                    <th>Sanctioned By</th>
                                                    <th>Loan Creation Date</th>
                                                    <th>Tranche Amount Total</th>
                                                    {/* <th>Tranche Status</th> */}
                                                    <th>Supplier Count</th>
                                                    <th>Tranche Active Count</th>
                                                    <th>Customer Mobile No.</th>
                                                    <th>RO - Assigned Contact No.</th>
                                                    <th>Tranche Closed Count</th>
                                                    <th>OD Status</th>
                                                    <th>DPD</th>
                                                    <th>Tranche O/S Total</th>
                                                    <th>Limit Available</th>
                                                    <th>OD Amount</th>
                                                    <th>Last Due Amount Total</th>
                                                    <th>Last Paid Amount Total</th>
                                                    <th>Last Due Date</th>
                                                    <th>Last Payment Date</th>
                                                    <th>Next Due Amount Total</th>
                                                    <th>Next Due Date</th>
                                                    <th>Next Demand Amount (inc. OD)</th>
                                                    <th>Cum. Interest Paid</th>
                                                    <th>Cum. Principal Paid</th>
                                                    <th>Cum. Interest Due</th>
                                                    <th>Cum. Principal Due</th>
                                                </tr>
                                                {/* <tr className="filter-row">
                                        <td>
                                            <input
                                                type="text"
                                                name="app_id"
                                                value={activeCustomerFilters?.app_id || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="branch_name"
                                                value={activeCustomerFilters?.branch_name || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="customer_name"
                                                value={activeCustomerFilters?.customer_name || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="customer_id"
                                                value={activeCustomerFilters?.customer_id || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                name="loan_id"
                                                value={activeCustomerFilters?.loan_id || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td></td>
                                        <td>
                                            <input
                                                type="text"
                                                name="ro_name"
                                                value={activeCustomerFilters?.ro_name || ""}
                                                placeholder="Search"
                                                className="column-filter"
                                                onChange={handleFilterChange}
                                            />
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td>
                                            <DatePicker
                                                selectsRange
                                                startDate={startDate}
                                                endDate={endDate}
                                                onChange={handleDateRangeChange}
                                                isClearable
                                                placeholderText="Select date range"
                                                className="form-control form-control-sm date-picker-filter"
                                            />
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr> */}
                                            </thead>
                                            <tbody>
                                                {
                                                    activeCustomerReport?.length === 0 ?
                                                        <tr>
                                                            <td colSpan={10} className="no-data-cell">
                                                                No records found
                                                            </td>
                                                        </tr> :
                                                        activeCustomerReport?.map((activeCustomer, index) => (
                                                            <tr key={index}>
                                                                <td>{activeCustomer?.app_id}</td>
                                                                <td>{activeCustomer?.branch_name}</td>
                                                                <td>{activeCustomer?.customer_name}</td>
                                                                <td>{activeCustomer?.customer_id}</td>
                                                                <td>{activeCustomer?.loan_id}</td>
                                                                <td>{activeCustomer?.tranche_ids?.join(', ')}</td>
                                                                <td>{activeCustomer?.ro_name}</td>
                                                                <td>{activeCustomer?.sanction_amount}</td>
                                                                <td>{activeCustomer?.sanction_by}</td>
                                                                <td>{activeCustomer?.loan_created_at}</td>
                                                                <td>{activeCustomer?.tranche_amount}</td>
                                                                {/* <td>{}</td> */}
                                                                <td>{activeCustomer?.supplier_count}</td>
                                                                <td>{activeCustomer?.active_tranche_count}</td>
                                                                <td>{activeCustomer?.customer_phone_number}</td>
                                                                <td>{activeCustomer?.ro_assigned_contact_no}</td>
                                                                <td>{activeCustomer?.closed_tranche_count}</td>
                                                                <td>{activeCustomer?.od_status}</td>
                                                                <td>{activeCustomer?.dpd}</td>
                                                                <td>{activeCustomer?.tranche_os_total}</td>
                                                                <td>{activeCustomer?.limit_available}</td>
                                                                <td>{activeCustomer?.current_od_amt_total}</td>
                                                                <td>{activeCustomer?.last_due_amt_total}</td>
                                                                <td>{activeCustomer?.last_paid_amt_total}</td>
                                                                <td>{activeCustomer?.last_due_date}</td>
                                                                <td>{activeCustomer?.last_payment_date}</td>
                                                                <td>{activeCustomer?.next_due_amount}</td>
                                                                <td>{activeCustomer?.next_due_date}</td>
                                                                <td>{activeCustomer?.next_demand_amount}</td>
                                                                <td>{activeCustomer?.cumulative_interest_paid}</td>
                                                                <td>{activeCustomer?.cumulative_principal_paid}</td>
                                                                <td>{activeCustomer?.cumulative_interest_due}</td>
                                                                <td>{activeCustomer?.cumulative_principal_due}</td>
                                                            </tr>
                                                        ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>

                                    {activeCustomerReport?.length > 0 && <div className="paginationControls">
                                        <CustomPagination
                                            currentPage={currentPage}
                                            totalPages={totalPages}
                                            onPageChange={handlePageChange}
                                        />
                                    </div>}
                                </main>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                showDownloadModal && (
                    <DownloadReport
                        isOpen={showDownloadModal}
                        onClose={() => setShowDownloadModal(false)}
                        reportTitle={"active-customer"}
                    />
                )
            }
        </>
    )
}

export default ActiveCustomer